import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const SkillBar = ({ level }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();

  React.useEffect(() => {
    if (inView) {
      controls.start({ width: `${level}%` });
    } else {
      controls.start({width: 0});
    }
  }, [controls, inView, level]);

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial={{ width: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      className="h-2 rounded-full bg-gradient-to-r from-steelBlue to-lightBlue"
    />
  );
};
// Example skills data structure
const skills = [
  { name: 'Python', level: 90 },
  { name: 'Microsoft Fabric', level: 90 },
  { name: 'SQL', level: 80 },
  { name: 'Machine learning', level: 75 },
  { name: 'Deep Learning', level: 70}, 
  { name: 'Java', level: 65 },
  { name: 'APIs', level: 65 },
  { name: 'AWS', level: 65 },
  { name: 'Azure', level: 60 },
  { name: 'React Framework', level: 60 },
  { name: 'PowerBI', level: 50 },
  { name: 'Linux', level: 50 },
  { name: '.NET', level: 50 },
  { name: 'Bash', level: 40 },
  // Add more skills as needed
];

function Skills() {
    return (
      <section id="skills" className="text-offWhite body-font">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-wrap -m-4">
            {skills.map(skill => (
              <div key={skill.name} className="p-4 md:w-1/2 w-full">
                <div className="h-full bg-blueGray border border-steelBlue/40 rounded overflow-hidden">
                  <div className="w-full p-4">
                    <h2 className="title-font font-medium text-3xl text-offWhite">{skill.name}</h2>
                    <SkillBar level={skill.level} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
  
  export default Skills;